const useGetNestedOccurence = () => {

  const getNestedOccurence = (containers, id, metaData) => {
    if (metaData.length != 0) return metaData; 
      containers.metaData.map(container => {
        if (container.id == id) metaData.push(container.metaData);
        if (container.metaData)
          getNestedOccurence(container, id, metaData);
      }
    )
  };

  return getNestedOccurence;
};

export default useGetNestedOccurence;
